import { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogOut, User } from "lucide-react";
import localStorageService from "../../core/services/local-storage-service";

export default function CoachTeamMemberHeader() {
    const user = localStorageService.getUserDetails("userDetails");
    debugger
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ddRef = useRef(null);
  const btnRef = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => {
      if (
        ddRef.current &&
        !ddRef.current.contains(e.target) &&
        btnRef.current &&
        !btnRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };

    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };

    document.addEventListener("click", onDocClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("click", onDocClick);
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  const handleLogout = () => {
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch (e) {
      // ignore
    }
    navigate("/admin/login");
  };

  const initials = (() => {
    const name = (user && (user.name || user.fullName || user.firstName)) || "";
    if (!name) return "U";
    return name
      .split(" ")
      .map((n) => n[0])
      .slice(0, 2)
      .join("")
      .toUpperCase();
  })();

  return (
    <header className="app-header" role="banner">
      <Link to="/admin/dashboard" className="brand" aria-label="RescueRN dashboard">
        <img src="https://res.cloudinary.com/dhhzpdckr/image/upload/v1758128880/rescuernlogo_dsi3mf.png" alt="RescueRN" />
      </Link>

      <div style={{ position: "relative" }}>
        <button
          ref={btnRef}
          type="button"
          className="user-btn"
          aria-haspopup="true"
          aria-expanded={open}
          onClick={() => setOpen((s) => !s)}
        >
          <div className="avatar" aria-hidden>
            {user && user.avatar ? (
              <img src={user.avatar} alt={user?.name || "User"} />
            ) : (
              <div style={{ color: "var(--brand-navy)", fontWeight: 600 }}>{initials}</div>
            )}
          </div>

          <div className="user-info" aria-hidden>
            <span className="name">{user?.name || user?.fullName || "User"}</span>
            <span className="role">{user?.role === 'team_member' ? "Team Member" : "Coach" || "Member"}</span>
          </div>
        </button>

        {open && (
          <div className="dropdown-panel shadow-sm" ref={ddRef} role="menu" aria-label="User menu">
            <Link
              to="/admin/profile"
              className="d-flex align-items-center"
              onClick={() => setOpen(false)}
              role="menuitem"
            >
              <User size={16} />
              <strong>Profile</strong>
            </Link>

            <button
              type="button"
              className="d-flex align-items-center"
              onClick={handleLogout}
              role="menuitem"
              style={{ color: "#d9534f" }}
            >
              <LogOut size={16} />
              <strong>Logout</strong>
            </button>
          </div>
        )}
      </div>
    </header>
  );
}